import api from '@/api';
import { defaultAvatarUrl } from '@/config/constants';
import useMeQuery from '@/api/queries/me/useMeQuery';
import { useMutation } from '@tanstack/vue-query';
import { AxiosError } from 'axios';
import type { Ref } from 'vue';
import { computed } from 'vue';

const postAvatar = async (formData: FormData, uuid?: string) => {
  if (!uuid) throw new AxiosError('UUID is mandatory to change avatar');

  const res = await api<void>({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    url: `/user/${uuid}/avatar`,
    data: formData,
  });

  return res;
};

export function useAvatarMutation(blob?: Ref<Blob | undefined>) {
  const { auth } = useMeQuery();

  const data = computed(() => {
    const dataValue = blob?.value ? blob.value : defaultAvatarUrl;
    const formData = new FormData();

    formData.append('avatar', dataValue);
    return formData;
  });

  const { mutateAsync: updateAvatar } = useMutation({
    mutationFn: () => postAvatar(data.value, auth.value?.uuid),
  });

  return { updateAvatar };
}
